"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationEngine = void 0;
const index_1 = require("./index");
class ValidationEngine {
    validate(validators) {
        let validations = [];
        for (const validator of validators) {
            validations = validations.concat(validator.bundler.getValidations(validator.target));
        }
        return (0, index_1.validate)(validations);
    }
}
exports.ValidationEngine = ValidationEngine;
